/* external */

/* internal */
import {
  SCORE_BASED,
  STANDARD_BASED,
  MYP_CRITERIA_BASED,
  CURRICULUM_TYPE_MYP,
  MANUAL,
} from "Constants/stringConstants";

/* relative */

export const APPLICABLE_GRADING_PERIODS = "APPLICABLE_GRADING_PERIODS";
export const COURSE_ID = "COURSE_ID";

// TODOGS2: update locales
export const GRADING_METHODOLOGY_TYPES = [
  {
    uid: MYP_CRITERIA_BASED,
    locale_header: "academicSetup:myp_criteria_based_grading",
    locale_key: "academicSetup:myp_criteria_based_grading_description",
    checkIsHidden: params => params?.curriculumType !== CURRICULUM_TYPE_MYP,
  },
  {
    uid: SCORE_BASED,
    locale_header: "academicSetup:score_or_letter_based_grading",
    locale_key:
      "Scores and grades are calculated by aggregating student's results from individual tasks, typically using methods such as totals or averages.",
  },
  {
    uid: STANDARD_BASED,
    locale_header: "academicSetup:standard_based_grading",
    locale_key:
      "Grades are derived based on student's performance against learning standards and reflect their level of mastery.",
  },
  {
    uid: MANUAL,
    locale_header: "progressSummary:manually_assign_a_grade",
    locale_key: "progressSummary:grades_are_not_autocalculated",
    checkIsHidden: params => !params?.isGradeScale,
  },
];

export const VISIBLE_FOR_PAST_GRADING_PERIODS =
  "VISIBLE_FOR_PAST_GRADING_PERIODS";
export const ALWAYS_VISIBLE = "ALWAYS_VISIBLE";
export const ALL_STANDARDS = "ALL_STANDARDS";
export const GRADED_STANDARDS = "GRADED_STANDARDS";
export const HIDDEN = "HIDDEN";

export const ENABLE_CREDITS_SETTING = "EnableCredits";
export const ENABLE_GPA_SETTING = "EnableGPA";
